import { render, staticRenderFns } from "./DropdownInputBlock.vue?vue&type=template&id=22fd6ca0"
import script from "./DropdownInputBlock.vue?vue&type=script&lang=ts"
export * from "./DropdownInputBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports